export * as specMapUtils from './utils/specMapUtils'
